<p-panel styleClass="pt-3 p-panel-slimheight">
	<ng-template pTemplate="header">
		<div class="flex align-items-center">
			<span class="font-semibold">{{ 'STATE_INPUTS' | translate }}</span>
		</div>
	</ng-template>
	<ng-template pTemplate="icons">
		<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom" (click)="editAlias()"
			[text]="true" severity="secondary" [disabled]="!deviceConfigured || !device.CurrentlyOwned">
		</p-button>
	</ng-template>
	<div class="grid pt-1">
		<div class="col-3 flex align-items-center justify-content-center gap-3" *ngFor="let o of inputArray; index as i">
			<span>{{ i + 1 }}</span>
			<label>{{translateDataAlias(i + 1)}}</label>
			<p-tag [value]="stateLabel(i, o)" [severity]="o ? 'success' : 'danger'"></p-tag>
			<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom"
				(click)="editState(i)" [text]="true" severity="secondary"
				[disabled]="!deviceConfigured || !device.CurrentlyOwned">
			</p-button>
		</div>
	</div>
</p-panel>